import { Component, OnInit, ViewChild, ElementRef,  ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";

import {
	GlobalDataOpsService,
	GlobalDomOpsService,
	AcepSSOService
} from "@acepteam/globalspack";
import { DomService, DataService, LoggerService } from "./core/services";
import {
	Router,
	ActivatedRoute,
	NavigationStart,
	NavigationEnd,
	ParamMap
} from "@angular/router";
import {
	GroupPortalDataService,
	GroupPortalDomService
} from "./groupportal/services";

import { Title } from "@angular/platform-browser";
import { environment } from "../environments/environment";


declare var $: any;
@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
	private subscriptions: Array<Subscription> = [];
	isGroupSearch: boolean = false;

	csspath: string = '';
	@ViewChild("acepMaster") acepMaster: ElementRef;
	env: string = environment.env;
	ssoUser: any = "";

    //AkshayG: Side bar Nav Height changes
    sideNavHeight:number = 700;
	@ViewChild('routerComp', { static: false }) routerComp!: ElementRef;
	 
	//local variable to detect changes on dashboard
	private observer!: MutationObserver;
    

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private globalDataOpsService: GlobalDataOpsService,
		private globalDomOpsService: GlobalDomOpsService,
		private _ssoService: AcepSSOService,
		public dataService: DataService,
		private domService: DomService,
		private loggerService: LoggerService,
		public groupPortalDataService: GroupPortalDataService,
		private memberAppDomService: GroupPortalDomService,
		private elem: ElementRef,
		private titleService: Title,
		private cdr: ChangeDetectorRef
	) {
		this.globalDomOpsService.showwait();

		this.csspath = `${this.globalDataOpsService.BasePath}/globalstyles/css/${this.globalDataOpsService.ORG}.css`;

		this._ssoService.getMessage().subscribe(message => {
			// this.username = message.context.FirstName;
			// this.avatar = message.context.Avatar;
			let con = message.context;
			this.ssoUser = JSON.stringify({
				acepid: con.ContactNumber,
				firstName: con.FirstName,
				avatar: con.Avatar,
				loginUI_ExpiryDate: con.LoginUI_ExpiryDate,
				loginUI_Join: con.LoginUI_Join
			});


			if (!!!this.acepMaster.nativeElement.ssouser) {
				this.acepMaster.nativeElement.setAttribute("ssouser", this.ssoUser);
			}


			//this.loginheader.user = this.user;
		});



		//Subscriptions
		let routerEventsSubscription: Subscription = this.router.events.subscribe(
			event => {
				if (event instanceof NavigationStart) {
					 

					this.isGroupSearch = event.url.indexOf('groupsearch') > -1;
					//Set Browser title
					let title = this.isGroupSearch ? 'Employer Profile Search' : 'Group Portal'
					this.titleService.setTitle(`American College of Emergency Physicians - ${title}`);


					//console.log('NavigationEnd:', event);

					if (event.id == 1) {						 
						//it means this is the first page laoded//
						//in this case there should be no animation in routing on page
						//this.dataservice.navigationDirection = "";

					} 
				} else if (event instanceof NavigationEnd) {
					//this.routename = this.router.url.replace('/', '');
					this.dataService.routename = event.url.replace("/", "");
					//this.loggerService.logInfo(`ROUTE NAME - ${this.dataService.routename}`);

					//GOOGLE ANALYTICS
					// this.globalDataOpsService.InjectAnalytics(event.urlAfterRedirects);				 
					 
				}			 
				 
			}
		);
	} 
	
	 //AkshayG: Side bar Nav Height changes
	ngAfterViewInit(): void {
		
		//AkshayG:Whenever anything changes in the DOM of the routerComp, it will detect change and apply the height
		const routerCompNativeElement = this.routerComp.nativeElement;
		this.observer = new MutationObserver((mutationsList, observer) => {
		// Handle changes here
		this.setSideNavHeight();
		// You can perform further actions based on the changes
		this.cdr.detectChanges(); // You may need to trigger change detection if needed
		});

		// Start observing changes
		this.observer.observe(routerCompNativeElement, { attributes: true, childList: true, subtree: true });
 

	  }
	
	 //AkshayG: Calculate the dashboard height and set it to the left nav 
	 setSideNavHeight(): void {
		 
			// Get the height of the routerComp element
			if (this.routerComp && this.routerComp.nativeElement) {

				//AkshayG:hide routeComp div when there is nothing in it to display to avoid extra space
				if(this.groupPortalDataService.headerInfo.groupId){
					this.routerComp.nativeElement.style.display = 'block'
				}else{
						this.routerComp.nativeElement.style.display = 'none'
				}
				
				const headerHeight = 70;
			const routerCompHeight = this.routerComp.nativeElement.offsetHeight;
			

			// Calculate the remaining height by subtracting the footer height from the scroll height
			const remainingHeight = routerCompHeight + headerHeight;

			// Set the height of the left navigation div to the remaining height
			this.sideNavHeight = remainingHeight < 700 ? 700 : remainingHeight;
			
			}

	 
  }

 




//End AkshayG: Side bar Nav Height changes
	ngOnInit(): void {
		$(function () {
			$('[data-toggle="popover"]').popover();
		});



		//   let id = this.route.snapshot.paramMap.get('groupId');
		//   this.groupPortalDataService.groupList.groupNumber = id;

		// var menu = document.querySelector("#GPsidenav");
		// var menuPosition = menu.getBoundingClientRect();
		// console.log(menuPosition);
		// var placeholder = document.createElement("div");
		// placeholder.style.width = menuPosition.width + "px";
		// placeholder.style.height = menuPosition.height + "px";
		// var isAdded = false;

		// window.addEventListener("scroll", function() {
		//   $("#sidebar").removeAttr("style");
		//   if (window.pageYOffset >= menuPosition.top && !isAdded) {
		//     menu.classList.add("sticky");
		//     menu.parentNode.insertBefore(placeholder, menu);
		//     isAdded = true;
		//   } else if (window.pageYOffset < menuPosition.top && isAdded) {
		//     menu.classList.remove("sticky");
		//     menu.parentNode.removeChild(placeholder);
		//     isAdded = false;
		//   }
		// });
	}

	ngOnDestroy() {
		// Disconnect the observer to avoid memory leaks
		this.observer.disconnect();
	  }

	logout() {
		this._ssoService.showwait();
		this._ssoService.logout();
	}

}
